import React from 'react';
import {
  Input, Select,
} from 'antd';
import {
  Box, Text,
} from '../../shared/components';

export default function MotivosDevolucion({
  onChangeNotaMotivoDevolucion, onChangeMotivosDevolucion, motivosDevolucion,
}) {
  let content = '';
  const { Option } = Select;
  const { TextArea } = Input;
  const motivosDevolucionArray = (typeof (motivosDevolucion) !== 'undefined') ? motivosDevolucion : [];

  content = (
    <Box>
      <Box mt="16">
        <Text fontSize="16" style={{ width: '266px', height: '32px' }}><b>Motivos</b></Text>
      </Box>

      <Box>
        <Text fontSize="14" style={{ width: '549px', height: '24px' }}>Motivo de la devolución</Text>
      </Box>

      <Box>
        <Select
          placeholder="Seleccione un motivo de devolución"
          style={{ width: '549px', height: '32px' }}
          onChange={onChangeMotivosDevolucion}
        >
          {motivosDevolucionArray.map(item => (
            <Option key={item.id} value={item.id}>{item.motivo}</Option>
          ))}
        </Select>
      </Box>

      <Box mt="16">
        <Text fontSize="14" style={{ width: '549px', height: '24px' }}>Notas</Text>
      </Box>

      <Box>
        <TextArea onChange={onChangeNotaMotivoDevolucion} rows={4} autoSize={{ minRows: 4, maxRows: 4 }} />
      </Box>
    </Box>

  );

  return content;
}
